import { Switch } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import { useEffect, useState } from "react";

const BooleanInput = ({ value, PI, label, onChange, child }) => {
	const [checked, setChecked] = useState(Boolean(value));

	const handleCheck = e => {
		if (PI) {
			setChecked(!checked);
			let event = { target: { name: child, value: !checked } };
			onChange(event);
		}
	};

	// init value for first render
	useEffect(() => {
		let event = { target: { name: child, value: checked } };
		onChange(event);
	}, []);

	return (
		<MDBox
			display="flex"
			justifyContent="space-between"
			alignItems="center"
			className="customSwitchContainer"
			onClick={e => handleCheck(e)}
		>
			<span>{label}</span>
			<MDBox>
				<Switch checked={checked} />
			</MDBox>
		</MDBox>
	);
};

export default BooleanInput;
